import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { Button, FinancieraLogo, OfertaCardData } from "@components/ui_v2";

const NOTA_TEXT = "#5C6B7C";
const DIALOG_SCRIM = "rgba(6, 44, 78, 0.55)";

interface Props {
  oferta: OfertaCardData;
  disabled: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirmación para aceptar una preoferta y rechazar el resto. */
export const DialogConfirmarOferta = ({ oferta, disabled, onConfirm, onClose }: Props) => (
  <Dialog
    open
    onClose={onClose}
    fullWidth
    PaperProps={{ sx: { maxWidth: 440, borderRadius: "18px", boxShadow: "0 24px 64px rgba(6, 44, 78, 0.35)" } }}
    slotProps={{ backdrop: { sx: { bgcolor: DIALOG_SCRIM, backdropFilter: "blur(4px)" } } }}
  >
    <DialogContent sx={{ p: "30px 28px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 40,
          mb: "18px",
        }}
      >
        <FinancieraLogo logo={oferta.logo} financiera={oferta.financiera} maxHeight={40} maxWidth="70%" />
      </Box>

      <Typography sx={{ fontWeight: 600, fontSize: 20, color: "primary.dark", textAlign: "center", mb: "10px" }}>
        ¿Confirmas esta preoferta?
      </Typography>
      <Typography
        sx={{
          fontSize: 14.5,
          lineHeight: 1.55,
          color: NOTA_TEXT,
          textAlign: "center",
          mb: "24px",
          "& strong": { color: "primary.dark" },
        }}
      >
        Continuarás con la preoferta de <strong>{oferta.financiera}</strong>. Al confirmar,{" "}
        <strong>las demás preofertas serán rechazadas</strong>
        {/* Copy del legacy para la rama con garantía: el proceso de aceptación es distinto. */}
        {oferta.conGarantia ? (
          <>
            {" y, como esta preoferta pide garantía, primero registrarás la "}
            <strong>información del bien en garantía</strong> para poder formalizar con la financiera.
          </>
        ) : oferta.digital ? (
          <>
            {" y pasarás al "}
            <strong>entorno digital de {oferta.financiera}, powered by Lendia,</strong> para concluir tu oferta ahí.
          </>
        ) : (
          <>
            {" y pasarás a tu "}
            <strong>Expediente digital</strong> para subir los documentos y formalizar con la financiera seleccionada.
          </>
        )}
      </Typography>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Button
          tone="outline"
          fullWidth
          disabled={disabled}
          onClick={onClose}
          data-testid="ofertas-confirmar-dialog-cancel-button"
        >
          Cancelar
        </Button>
        <Button
          tone="accent"
          fullWidth
          disabled={disabled}
          onClick={onConfirm}
          data-testid="ofertas-confirmar-dialog-confirm-button"
        >
          Sí, continuar
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);
